import editTagReducer from './editTagReducer';

export default editTagReducer;
